module.exports = __webpack_public_path__ + "media/images/icon-keyboard-arrow-right-57859abf987284bc0fae8a448e2d1740.svg";